import {iframeToSdkChannel} from "../messaging/IframeToSdkChannel";
import {IFrameMessages} from "../messaging/IFrameMessages";
import {userDataModule} from "./UserDataModule";
import {WidgetRoutes} from "../../blinkpay/widget/WidgetRoutes";
import {PANEL_TYPE, type PanelType} from "../Constants";
import {panelModule} from "./PanelModule";
import {walletModule} from "./WalletModule";
import {openWindowWithOpener} from "../../blinkpay/UtilsLib";
import {sdkState} from "./SDKState";
import {AnalyticsEventType, dispatchAnalyticsEvent} from "../utils/AnalyticsClient";
import {getMerchantPanel} from "./PublicData";
import {type PanelPromptOptions} from "../PanelOptionsLogic";

interface RedirectToUrlMessage {
    url?: string;
    newTab?: boolean;
    logOut?: boolean;
}

interface StartFlowRequestMessage {
    flowType: PanelType;
    options: FlowOptions;
}

// A flow is entered with the panel options the caller wrote, plus the journey that asked for it
interface FlowOptions extends PanelPromptOptions {
    flowType?: string;
    journeyId?: string | number;
    journeyAlias?: string;
    [key: string]: any;
}

interface AnalyticsEventPayload {
    flowType: string;
    // Ids as public data carries them, which is a number for anything from the backend
    journeyId?: string | number;
    journeyAlias?: string;
    panelId?: string | number;
    panelAlias?: string;
    [key: string]: any;
}

class UXFlowModule {
    init(): void {
        // The current merchant's page will be refreshed if no specific URL is provided
        iframeToSdkChannel.addListener(IFrameMessages.REDIRECT_TO_URL, ({url, newTab, logOut}: RedirectToUrlMessage) => {
            if (logOut) {
                userDataModule.setMerchantToken(null);
            }
            openWindowWithOpener(url || window.location.href, newTab ? "_blank" : "_self");
        });

        iframeToSdkChannel.addListener(IFrameMessages.START_FLOW_REQUEST, ({flowType, options}: StartFlowRequestMessage) => this.enterFlow(flowType, options));
    }

    enterFlow(flowType: PanelType, options: FlowOptions): void {
        options.type = options.type || flowType;
        options.flowType = flowType;
        const analyticsEventPayload: AnalyticsEventPayload = {
            flowType: options.type,
            journeyId: options.journeyId,
            journeyAlias: options.journeyAlias,
            ...options.metadata,
        };
        const panel = getMerchantPanel(options.panel);
        if (panel) {
            analyticsEventPayload.panelId = panel.id;
            analyticsEventPayload.panelAlias = panel.alias;
        }

        // TODO I think we need to have all these values inside the analytics environment
        dispatchAnalyticsEvent(AnalyticsEventType.FLOW_START, analyticsEventPayload);

        if (!options.editRecurring
            && ((flowType === PANEL_TYPE.subscribe && userDataModule.userData.subscription)
                || (flowType === PANEL_TYPE.donation && userDataModule.isRecurringDonor()))) {
            if (sdkState.hideWallet) {
                // TODO @cleanup @branch fuck this complexity
                panelModule.createPopup({
                    ...options,
                    type: PANEL_TYPE.dashboard,
                });
            } else {
                walletModule.changeRoute(WidgetRoutes.INDEX_EXPANDED);
            }
        } else {
            panelModule.createPopup(options);
        }
    }
}

export const uxFlowModule = new UXFlowModule();